<script lang="ts">
    import cn from '$common/utils/cn';
    import {
        VpAddIcon,
        VpSubtractIcon,
    } from '@decathlon-experience/icons/svelte';

    export let value: string;
    export let max: string | number | null | undefined = undefined;
    export let min: string | number | null | undefined = undefined;
    export let onIncrement: (event: Event) => void = () => {};
    export let onDecrement: (event: Event) => void = () => {};
    export let inputClasses: string = '';
    export let plusBtnClasses: string = '';
    export let minusBtnClasses: string = '';
    export let id = '';
    export let name = '';
    export let inputProps = {};
    export let minusBtnProps = {};
    export let plusBtnProps = {};
</script>

<div class="flex">
    <button
        type="button"
        class={cn(
            'incrementBtn !rounded-r-none !border-r-0 text-content-neutral',
            minusBtnClasses,
        )}
        on:click={onDecrement}
        {...minusBtnProps}
    >
        <VpSubtractIcon size={16} />
    </button>
    <input
        {id}
        {name}
        type="number"
        class={cn(
            '!w-4xl !rounded-none !border-x-0 !border-y !border-solid !border-border-quiet !py-s text-center !text-xs !shadow-[inset_0_0_0_0]',
            inputClasses,
        )}
        {max}
        {min}
        bind:value
        {...inputProps}
    />
    <button
        type="button"
        class={cn(
            'incrementBtn !rounded-l-none !border-l-0 text-content-neutral',
            plusBtnClasses,
        )}
        on:click={onIncrement}
        {...plusBtnProps}
    >
        <VpAddIcon size={16} />
    </button>
</div>

<!--    Remove arrows inside input -->
<style lang="postcss">
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    input[type='number'] {
        -moz-appearance: textfield;
    }

    .incrementBtn {
        @apply touch-manipulation rounded-full border border-solid border-border-quiet p-m enabled:hover:bg-secondary-regular-container-hover enabled:active:bg-active-primary;
    }
</style>
